import { IAnalyticsProvider } from './types';

let provider : IAnalyticsProvider | undefined;

function registerProvider(instance : IAnalyticsProvider) : void {
  if (provider) {
    throw new Error();
  }

  provider = instance;
}

export default {
  registerProvider,
  trackPurchase: (orderData: any) => provider?.trackPurchase(orderData),
};